module.exports = __webpack_public_path__ + "img/icono_corona.e71a595f.png";